export default __webpack_public_path__ + "static/media/a020-ngo-3.34cca679.svg";